import React, { useState, useEffect } from "react";
import clsx from "clsx";
import Dropdown from "react-bootstrap/Dropdown";
import RlNavigationItem from "./RlNavigationItem";

type RlNavigationDropdownItemProps = {
  title: string | React.ReactNode;
  children: React.ReactNode;
  className?: string;
  openOnHover?: boolean;
  showCaret?: boolean;
  id: string;
  parentCloseControl?: {
    close?: boolean;
    setClose?: React.Dispatch<React.SetStateAction<boolean>>;
  };
};

const RlNavigationDropdownItem = ({
  title,
  children,
  className,
  openOnHover = false,
  showCaret = false,
  id,
  parentCloseControl
}: RlNavigationDropdownItemProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  useEffect(() => {
    if (!parentCloseControl?.close) {
      return;
    } else {
      setShowDropdown(false);
    }
  }, [parentCloseControl]);

  const handleMouseEnter = () => {
    if (openOnHover) setShowDropdown(true);
  };

  const handleMouseLeave = () => {
    if (openOnHover) setShowDropdown(false);
  };

  return (
    <Dropdown
      className={clsx(
        className,
        "main-nav__dropdown-container",
        `main-nav__dropdown-container--${id}`
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      data-testid={`dropdown_${id}`}
      id={id}
      show={showDropdown}
      onToggle={() => {
        setShowDropdown(!showDropdown);
        parentCloseControl?.setClose?.(false);
      }}
    >
      <Dropdown.Toggle
        className={clsx(
          "main-nav__item--dropdown",
          showCaret && "main-nav__item--dropdown-with-caret",
          openOnHover && "main-nav__item--dropdown-hover",
          `main-nav__item--dropdown-${id}`
        )}
        as={RlNavigationItem}
        testId={`dropdown_toggle_${id}`}
      >
        {title}
      </Dropdown.Toggle>
      <Dropdown.Menu
        variant="white"
        className={clsx("main-nav__submenu", `main-nav__submenu--${id}`)}
        align="end"
        popperConfig={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [5, -2]
              }
            }
          ]
        }}
        data-testid={`dropdown_menu_${id}`}
      >
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RlNavigationDropdownItem;
